/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Close from "../../../Helpers/CloseBtn/Close";
import { useNavigate } from "react-router-dom";
import { popupcontext } from "../../../../context/Popupscontext";
import trans from "../../../../utils";
import usePermission from "../../../../hooks/usePermission";

export default function PlayBackHead() {
	let { setDisplay, setPosIndex, setHistoryPlayback } =
		useContext(popupcontext);
	let navigate = useNavigate();
	const handleClose = async () => {
		await setDisplay(false);
		setHistoryPlayback({ state: false, Id: 0 });
		setPosIndex(0);
		navigate("/livetracking"); // Navigate to the home page
	};
	const { view } = usePermission("LIVETRACKING");
	return (
		<>
			<div className="history-playback-head">
				<div className="fs-16 fw-600 me-2">{trans("History Playback")}</div>

				{view && (
					<Close style="close close-32" img="Close" close={handleClose} />
				)}
			</div>
		</>
	);
}
